import { List, ListItem, ListItemText, Typography } from '@mui/material';

import { TimeAgo } from '@modules/_shared/components/TimeAgo';
import { formatAppraisalPrice } from '@modules/_shared/utils/formatting';
import { type Currency, type IntlLocale } from '@shared/LocaleContext';

export type AppraisalHistoryItem = {
  id: string;
  min?: number | null;
  max?: number | null;
  value?: number | null;
  created_at?: string | null;
};

type AppraisalHistoryListProps = {
  appraisals: AppraisalHistoryItem[];
  currency: Currency;
  locale: IntlLocale;
  emptyMessage: string;
};

export const AppraisalHistoryList = ({
  appraisals,
  currency,
  locale,
  emptyMessage,
}: AppraisalHistoryListProps) => {
  if (appraisals.length === 0) {
    return (
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          py: 2,
        }}
      >
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <List>
      {appraisals.map((appraisal, index) => (
        <ListItem key={appraisal.id} divider={index < appraisals.length - 1}>
          <ListItemText
            primary={formatAppraisalPrice(appraisal, currency, locale)}
            secondary={
              appraisal.created_at && (
                <TimeAgo addSuffix strict={false}>
                  {appraisal.created_at}
                </TimeAgo>
              )
            }
          />
        </ListItem>
      ))}
    </List>
  );
};
